module.exports = __webpack_public_path__ + "img/poly-10.390c4414.png";